module.exports = __webpack_public_path__ + "img/chevrons-left.4a2a0b47.svg";